import { View, ActivityIndicator, Text } from "react-native";

export function LoadingScreen() {
  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "#f9fafb" }}>
      <ActivityIndicator size="large" color="#2563eb" />
      <Text style={{ marginTop: 16, color: "#6b7280", fontSize: 16 }}>Loading...</Text>
    </View>
  );
}
